// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/Price/price.scss
// module id = 1430
// module chunks = 10